import Service from './Service'
import { DENUNCIATION } from './apiUrls'

export default class DenunciationService extends Service {
  getDuplicate (id) {
    return this.axios.get(`${DENUNCIATION}/${id}/duplicate`)
  }
}



// WEBPACK FOOTER //
// ./src/services/api/DenunciationService.js